import { Injectable } from '@angular/core';

import { ActivityInterface } from '../data';
import { MemoryCacheRepository } from './memory-cache.repository';

@Injectable()
export class ActivityCacheRepository extends MemoryCacheRepository<ActivityInterface[]> {}
